import { Middleware } from "../Middleware";
import { MiddlewareInterface } from "../MiddlewareInterface";

class ActivityTemplateCreateWillMount extends Middleware implements MiddlewareInterface {
  public component: any;

  constructor() {
    super();
  }

  public process(): void {
    let savedDataBeforeRedirecting: any = {};
    this.component.session = this.component.props.app.session.user;
    this.component.person = this.component.props.app.persons.filter(
      person => person.id === this.component.session.id
    )[0];

    if (Object.keys(this.component.props.app?.savedDataBeforeRedirecting || {}).length > 0) {
      const createdExecutor = this.component.props.app.savedDataBeforeRedirecting.executor &&
        this.component.props.app.savedDataBeforeRedirecting.executor;

      savedDataBeforeRedirecting = {
        ...this.component.props.app.savedDataBeforeRedirecting.activityTemplateCreateDataToBeSaved,
      };

      if (!!createdExecutor && !!savedDataBeforeRedirecting.activeTemplate) {
        savedDataBeforeRedirecting.activeTemplate.executorId = createdExecutor.id;
      }
    }

    this.component.setState({
      ...savedDataBeforeRedirecting
    });
  }
}

export default new ActivityTemplateCreateWillMount();
